import React from "react";

// Import Ionic
import { IonButton, IonCol, IonGrid, IonIcon, IonRow } from "@ionic/react";

// Import Icons
import { basket } from "ionicons/icons";
import { useTranslation } from "react-i18next";

interface IIsEmptyCart {
  openProductsPage: () => void;
}

const IsEmptyCart: React.FC<IIsEmptyCart> = ({ openProductsPage }) => {
  const { t } = useTranslation();

  return (
    <IonGrid class="ion-no-padding grid-cart">
      <IonRow>
        <IonCol className="ion-text-center" size="12">
          <IonIcon className="no-margin-icon" icon={basket} />
        </IonCol>
        <IonCol className="ion-text-center" size="12">
          <h4>{t("Your cart is empty")}</h4>
        </IonCol>
        <IonCol className="ion-text-center" size="12">
          <h5>{t("Continue Shopping")}</h5>
        </IonCol>
        <IonCol className="ion-text-center" size="12">
          <IonButton onClick={() => openProductsPage()}>{t("Explore")}</IonButton>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default IsEmptyCart;
